import { createSlice } from "@reduxjs/toolkit";
import {
  getSellerDashboardStatsByUserId,
  unsubscribeFromSellerStats,
} from "./dashboardActions";

const initialState = {
  sellerDashboardStats: null,
  isSellerDashboardStatsLoading: true,
  error: null,
  unsubscribe: null,
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    // Manual unsubscribe action if needed
    manualUnsubscribe: (state) => {
      if (state.unsubscribe) {
        state.unsubscribe();
        state.unsubscribe = null;
      }
    },
    // Update stats directly (for real-time updates after initial load)
    updateStats: (state, action) => {
      state.sellerDashboardStats = action.payload;
      state.isSellerDashboardStatsLoading = false;
    },
  },

  extraReducers: (builder) => {
    builder
      // Get Seller Dashboard Stats
      .addCase(getSellerDashboardStatsByUserId.pending, (state) => {
        state.isSellerDashboardStatsLoading = true;
        state.error = null;
      })
      .addCase(getSellerDashboardStatsByUserId.fulfilled, (state, action) => {
        state.unsubscribe = action.payload.unsubscribe;
        state.isSellerDashboardStatsLoading = false;
        state.error = null;
      })
      .addCase(getSellerDashboardStatsByUserId.rejected, (state, action) => {
        state.isSellerDashboardStatsLoading = false;
        state.error = action.payload;
        state.unsubscribe = null;
      })
      // Unsubscribe from real-time updates
      .addCase(unsubscribeFromSellerStats.fulfilled, (state) => {
        state.unsubscribe = null;
      });
  },
});

export const { clearError, manualUnsubscribe, updateStats } =
  dashboardSlice.actions;

export default dashboardSlice.reducer;
